import { DealSheetRulesFilterType } from './types';
import { DealSheetRulesFilters } from './filters/cards';

export const initialDealSheetRulesFiltersValue: DealSheetRulesFilters = {
  [DealSheetRulesFilterType.CUSTOMER_TYPE]: [],
  [DealSheetRulesFilterType.PAYMENT_TYPE]: [],
  [DealSheetRulesFilterType.EQUIPMENT_TYPE]: [],
  [DealSheetRulesFilterType.STATE]: [],
  [DealSheetRulesFilterType.COUNTRY]: [],
  [DealSheetRulesFilterType.PROVINCE]: [],
};
